import React from 'react';
import { AnimateOnScroll } from '../AnimateOnScroll';
export function FDAgingFat() {
  return <section className="bg-black py-[60px] lg:py-[100px] overflow-hidden" data-id="element-1083">
      <div className="max-w-[1200px] mx-auto px-6 lg:px-8" data-id="element-1084">
        <div className="flex flex-col-reverse lg:flex-row items-center gap-12 lg:gap-20" data-id="element-1085">
          {/* Left Column - Image */}
          <AnimateOnScroll className="w-full lg:w-[45%]" delay={200} data-id="element-1086">
            <div className="relative w-full aspect-[3/4] overflow-hidden shadow-xl" data-id="element-1087">
              <img src="https://cdn.magicpatterns.com/uploads/sCBkzyTtKJ4MMc1TWkcztz/stubborn-fat.jpg" alt="Stubborn Fat Treatment" className="w-full h-full object-cover" data-id="element-1088" />
            </div>
          </AnimateOnScroll>

          {/* Right Column - Text */}
          <AnimateOnScroll className="w-full lg:w-[55%]" data-id="element-1089">
            <h2 className="text-[26px] lg:text-[40px] uppercase text-white leading-tight mb-4 font-[600] font-[Poppins,_sans-serif]" data-id="element-1090">
              AGING & STUBBORN FAT
            </h2>

            <div className="w-[40px] h-[2px] bg-[#FF1493] mb-8" data-id="element-1091"></div>

            <div className="space-y-6 text-[#B0B0B0] text-base leading-[1.8] font-body" data-id="element-1092">
              <p data-id="element-1093">
                As men and women age, they often notice stubborn pockets of fat
                that seem to appear out of nowhere. This type of fat, commonly
                found around the abdomen, flanks, thighs, or chin, is a natural
                result of aging, driven by hormonal changes, slowed metabolism,
                and shifts in fat distribution.
              </p>
              <p data-id="element-1094">
                These fatty deposits are particularly frustrating because
                they're often "diet- and exercise-resistant." Once the body
                locks fat into these areas, breaking it down becomes harder, no
                matter how many workouts or clean meals you commit to. This is
                why targeted solutions like fat-dissolving injections or body
                contouring treatments become appealing options—they go directly
                to the source to address what diet and exercise alone can't.
              </p>
            </div>
          </AnimateOnScroll>
        </div>
      </div>
    </section>;
}